(() => {
  const mobile = () => matchMedia('(max-width: 768px)').matches;
  let counter = 0;
  function enhance() {
    document.querySelectorAll('collection-filtering-form, .bedz-ranked-controls').forEach(form => {
      const ranked = form.classList.contains('bedz-ranked-controls');
      if(ranked && form.querySelector('.bedz-filter-toggle')) return;
      let wrap = form.querySelector('.facets__wrapper');
      if(ranked){
        wrap=document.createElement('div');wrap.className='facets__wrapper';
        const labels=[...form.children].filter(e=>e.tagName==='LABEL');
        if(labels.length<2)return;
        labels[0].classList.add('sorting');
        labels.slice(1).forEach(e=>wrap.appendChild(e));form.prepend(wrap);
      }
      if (!wrap || wrap.closest('.bedz-filter-toggle')) return;
      const host = ranked ? form : form.closest('.collection-filters');
      if (!host) return;
      host.classList.add('bedz-compact-filters');
      const toggle = document.createElement('details');
      toggle.className = 'bedz-filter-toggle';
      const summary = document.createElement('summary');
      summary.textContent = 'Filters';
      summary.setAttribute('aria-controls', 'bedz-filter-panel-' + (++counter));
      const panel = document.createElement('div');
      panel.className = 'bedz-filter-panel'; panel.id = summary.getAttribute('aria-controls');
      panel.setAttribute('aria-label', 'Product filters');
      const heading = document.createElement('div'); heading.className = 'bedz-filter-panel__header';
      const title = document.createElement('strong'); title.textContent = 'Filters';
      const close = document.createElement('button'); close.type = 'button'; close.textContent = '×'; close.setAttribute('aria-label', 'Close filters');
      heading.append(title, close);
      const footer = document.createElement('div'); footer.className = 'bedz-filter-panel__footer';
      const clear = document.createElement('a');clear.textContent = 'Clear all';
      const url = new URL(location.href);url.pathname=url.pathname.replace(/(\/collections\/[^/]+)\/.*/, '$1');
      [...url.searchParams.keys()].forEach(k=>{if(k.startsWith('filter.') || k==='page')url.searchParams.delete(k)});
      clear.href = url.pathname + url.search;
      if(ranked){
        const chips=document.createElement('div');chips.className='bedz-filter-chips';form.appendChild(chips);
        const fields=[...wrap.querySelectorAll('input,select')];
        const updateChips=()=>{
          chips.replaceChildren();
          fields.filter(f=>f.value!=='').forEach(f=>{
            const chip=document.createElement('button');chip.type='button';
            chip.textContent=f.parentElement.firstChild.textContent.trim()+': '+f.value+' ×';
            chip.addEventListener('click',()=>{f.value='';f.dispatchEvent(new Event('input',{bubbles:true}));f.dispatchEvent(new Event('change',{bubbles:true}));updateChips()});chips.appendChild(chip);
          });
        };
        wrap.addEventListener('change',updateChips);wrap.addEventListener('input',updateChips);
        clear.addEventListener('click',e=>{e.preventDefault();fields.forEach(f=>{f.value='';f.dispatchEvent(new Event('input',{bubbles:true}));f.dispatchEvent(new Event('change',{bubbles:true}))});updateChips()});
      }
      const show = document.createElement('button');show.type='button';show.textContent='Show results';
      footer.append(clear,show);
      wrap.before(toggle); toggle.append(summary,panel); panel.append(heading,wrap,footer);
      const shut = () => { toggle.open=false;summary.focus();document.documentElement.classList.remove('bedz-filters-open'); };
      close.addEventListener('click',shut);show.addEventListener('click',shut);
      toggle.addEventListener('toggle',()=>{
        summary.setAttribute('aria-expanded',String(toggle.open));
        document.documentElement.classList.toggle('bedz-filters-open',toggle.open&&mobile());
        if(toggle.open&&mobile()){panel.setAttribute('role','dialog');panel.setAttribute('aria-modal','true');close.focus();}
        else {panel.removeAttribute('role');panel.removeAttribute('aria-modal');}
      });
      toggle.addEventListener('keydown',e=>{
        if(e.key==='Escape'){e.preventDefault();shut();}
        if(e.key==='Tab'&&toggle.open&&mobile()){
          const items=[...panel.querySelectorAll('button,a[href],input,select,summary')].filter(el=>!el.disabled&&el.getClientRects().length);
          const first=items[0],last=items[items.length-1];
          if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}
          else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}
        }
      });
      document.addEventListener('click',e=>{if(toggle.open&&!toggle.contains(e.target)&&!mobile())shut()});
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',enhance);else enhance();
  let pending=false;
  new MutationObserver(()=>{if(!pending){pending=true;requestAnimationFrame(()=>{pending=false;enhance()})}}).observe(document.documentElement,{childList:true,subtree:true});
  addEventListener('resize',()=>{if(!mobile())document.documentElement.classList.remove('bedz-filters-open')});
})();
